const {
    createBlobService
} = require('./azure-storage.blob.min.js');

import Guid from 'guid';
const CONTAIENRNAME = 'gtmblob';

const blobService = createBlobService(
    process.env.AZURE_ACCOUNT,
    process.env.AZURE_ACCESS_KEY
);

export const uploadLocalFile = async file => {
    return new Promise((resolve, reject) => {
        let stream = file.raw;
        let fielGuid = Guid.raw();
        let fileName =
            stream.name > '' ?
            stream.name.split('.')[0] +
            '&$_$&' +
            fielGuid +
            '.' +
            stream.name.split('.')[1] :
            fielGuid;

        blobService.createBlockBlobFromBrowserFile(
            CONTAIENRNAME,
            fileName,
            stream, {
                blockSize: 1024 * 1024 * 512
            },
            function (error, result, response) {
                if (error) {
                    // Upload blob failed
                    resolve(false);
                } else {
                    // Upload successfully
                    result.guid = fielGuid;
                    console.log(response);
                    resolve(result);
                }
            }
        );
    });
};

/**
 *
 * @param {二进制流}blob
 * @param {生成的文件名} fileName
 */
function buildFile(blob, fileName) {
    let ele = document.createElement('a');

    ele.innerHTML = fileName;
    ele.download = fileName;
    ele.href = URL.createObjectURL(blob);
    document.body.appendChild(ele);
    let evt = document.createEvent('MouseEvents');

    evt.initEvent('click', false, false);
    ele.dispatchEvent(evt);
    document.body.removeChild(ele);
}

/**
 * 
 * @param {bufferArray} content 
 * @param {文件名} filename 
 */
export function downloadFile(content, filename) {
    let blob = new Blob([content.data], {
        type: 'octet/stream'
    });
    let a = document.createElement('a');

    if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
    } else {
        document.body.appendChild(a);
        a.style = 'display:none';
        let url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
    }
}

export const downloadBlob = async blobName => {
    return new Promise((resolve, reject) => {
        blobService.getBlobToText(CONTAIENRNAME, blobName, (err, data) => {
            if (err) {
                reject(err);
            } else {
                let blob = new Blob([data], {
                    type: 'application/json'
                });

                buildFile(blob, blobName);
                resolve({
                    message: `Blob downloaded "${data}"`,
                    text: data
                });
            }
        });
    });
};



// WEBPACK FOOTER //
// ./src/utils/azure.js